<template>
  <div class='card-deck mb-3'>
    <header class="card-deck_header">
        {{ title }}
    </header>
    <div class="card-deck_body">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
}
</script>
